import * as act from '@/store/organization.actions';
import { organizationService } from '../services';
import { EventBus } from '@/helpers/event-bus';
import store from '@/store/store';
import { actions as storeActions } from '@/models/store.actions';

const state = {
  id: 0,
  edrpo: '',
  organisationNameUk: '',
  organisationNameEn: '',
  organisationNameRu: '',
  myOrganization: {
    code: '',
    name: ''
  }
};

const actions = {
  async [act.ACT_DETAILS]({ commit }) {
    return organizationService
      .get()
      .then(org => {
        commit(act.MUT_DETAILSSET, { org });
      })
      .catch(_error => {});
  }
};
const mutations = {
  [act.MUT_DETAILSSET](state: any, { org }): void {
    state.id = org.organisationId;
    state.edrpo = org.edrpo;
    state.organisationNameUk = org.organisationNameUk;
    state.organisationNameEn = org.organisationNameEn;
    state.organisationNameRu = org.organisationNameRu;
  },
  [act.MUT_DETAILSCLEAR](state: any): void {
    state.id = null;
    state.edrpo = null;
    state.organisationNameUk = null;
    state.organisationNameEn = null;
    state.organisationNameRu = null;
    store.commit(storeActions.ORG_MUT_MYORGCLEAR, { silent: true });
  },
  [act.MUT_MYORGSET](state: any, { myOrganization }): void {
    if (myOrganization) {
      state.myOrganization.code = myOrganization.code;
      state.myOrganization.name = myOrganization.name;
      EventBus.$emit('my-organization-changed');
    }
  },
  [act.MUT_MYORGCLEAR](state: any, prms): void {
    state.myOrganization.code = '';
    state.myOrganization.name = '';
    if (!prms || !prms.silent) {
      EventBus.$emit('my-organization-changed');
    }
  }
};
const getters = {
  [act.GET_DETAILS]: state => {
    return state;
  },
  [act.GET_MYORG]: state => {
    return JSON.parse(JSON.stringify(state.myOrganization));
  }
};

export const organization = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
